import Section from "../../components/section";
import FooterMenu from "./footer-menu";

function Footer(props) {
  return (
    <>
      <footer className="footer">
        <div className="container">
          <Section>
            <div className="row">
              <div className="col-md-6">
                © { new Date().getFullYear() } <span>Investičný holding</span>
              </div>
              <div className="col-md-6">
               <FooterMenu />
              </div>
            </div>
          </Section>
        </div>
      </footer>
    </>
  );
}

export default Footer
